import { Component, OnInit, Input } from '@angular/core';
import { PagesIncContainerService } from './pages-inc-container.service';

@Component({
  selector: 'fcp-pages-inc-container',
  template: `
    <fcp-pages-inc [src]="data"></fcp-pages-inc>
  `
})
export class PagesIncContainerComponent implements OnInit {
  @Input() public data: boolean;
  public page;
  constructor(private pagesIncContainerService: PagesIncContainerService) {}

  ngOnInit() {
    this.page = this.pagesIncContainerService.mapPageInc(this.data);
  }
}
